import { formatTime } from './format-time.js'

export function makeColumnDefsModules () {
  return [
    {
      headerName: 'Module',
      field: 'module'
    },
    {
      headerName: 'Status',
      field: 'status'

    },
    {
      headerName: 'Started At',
      valueGetter: function (cellParams) {
        return cellParams.data.started_at
      },
      valueFormatter: function (cellParams) {
        return formatTime(cellParams.value)
      }
    },
    {
      headerName: 'Ended At',
      valueGetter: function (cellParams) {
        return cellParams.data.ended_at
      },
      valueFormatter: function (cellParams) {
        return formatTime(cellParams.value)
      }
    }
  ]
}
